import { DOCUMENT_TYPES, TRoles } from './const'

/*
 * Welche eigenen Dokumente fehlen noch? (Anforderung #182)
 *
 * Eine Rechnung für drei Stellen: den Punkt am Reiter „Dokumente" im eigenen
 * Profil, den Hinweiskasten darin und das Warndreieck am eigenen Namen in der
 * Seitenleiste. Vorher stand sie nur im Profil (views/student/Profile) — eine
 * zweite Fassung in der Seitenleiste wäre beim nächsten neuen Dokument
 * auseinandergelaufen.
 *
 * Gemessen wird wie an der Karte selbst (ParentalConfirmation): Ein Dokument fehlt, solange keines hochgeladen ist oder
 * die Verwaltung das hochgeladene beanstandet hat — dann muss ein neues her.
 * Ob die Verwaltung es schon **geprüft** hat, zählt hier nicht.
 *
 * Eigene Dokumente haben nur Schüler:innen. Für jede andere Rolle ist die
 * Liste leer — eine Lehrkraft bekommt also kein Dreieck.
 *
 * Bis 31.10.2026 zählte hier auch der Kursnachweis mit, wo die Einstellung
 * `courseCertificateRequirement` ihn verlangte. Er ist ausgebaut; bereits
 * hochgeladene Nachweise bleiben als Dokumente stehen, fehlen kann keiner mehr.
 */

/**
 * Die fehlenden Dokumente als Liste von `{ type, rejected }`.
 *
 * @param {object} profile  state.user.profile
 */
export const missingDocuments = profile => {
	if (!profile) return []

	const has = type => !!profile.Documents?.find(item => item.type === type)
	const missing = []

	if (!has(DOCUMENT_TYPES.PARENTAL_CONFIRMATION) || profile.rejectedParentalConfirmation) {
		missing.push({
			type: DOCUMENT_TYPES.PARENTAL_CONFIRMATION,
			rejected: !!profile.rejectedParentalConfirmation
		})
	}

	return missing
}

/** Dieselbe Liste aus dem Store — nur für die eigene Rolle Schüler:in. */
export const selectMissingDocuments = state =>
	state.user.role === TRoles.STUDENT ? missingDocuments(state.user.profile) : []

/** Adresse des eigenen Profils mit dem Reiter „Dokumente". */
export const PROFILE_DOCUMENTS_TAB = 'documents'
